import saveUserV2SalesforceMutation from 'graphql-tag';

export default saveUserV2SalesforceMutation`
  mutation saveUserSalesforce($refreshToken: String!, $accessToken: String!) {
    saveUserV2(refreshToken: $refreshToken, accessToken: $accessToken)
  }
`;
